import React from "react";

import {
    faBackwardStep,
    faChevronLeft,
    faChevronRight,
    faForwardStep,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Document, Page,pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = process.env.REACT_APP_PUBLIC_URL
  ? `${process.env.REACT_APP_PUBLIC_URL}/pdfjs-dist/worker/pdf.worker.min.mjs`
  : new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

interface PdfViewerProps {
    selectFile: any;
    className?: string;
}

const PdfViewer = (props: PdfViewerProps) => {
    const { selectFile, className } = props;

    const [numPages, setNumPages] = React.useState<number>(0);
    const [page, setPage] = React.useState<number>(1);
    const [fileNumber, setFileNumber] = React.useState<number>(0);
    const [error, setError] = React.useState(null);

    const onDocumentLoadSuccess = async ({ numPages: nextNumPages }: any) => {
        setNumPages(nextNumPages);
        setError(null);
    };

    React.useEffect(() => {
        setFileNumber(0);
        setPage(1);
    }, [selectFile]);

    return (
      <div className={`${className} select-none h-100`}>
        {selectFile?.length ? (
          <>
            {error && (
              <div className="bg-[#f7fafd] h-[calc(100vh-135px)] smd:h-[calc(100vh-200px)] flex items-center justify-center">
                <div className="text-xs font-bold text-heading px-3 text-justify">
                  “Unfortunately, document previews are not supported for .docx
                  or .doc, only PDF's at this time. However, you will still be
                  able to send your document without a problem”.
                </div>
              </div>
            )}
            <Document
              file={selectFile[fileNumber]?.originFileObj}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(error: any) => setError(error.message)}
            >
              <Page pageNumber={page} />
            </Document>
            {!error ? (
              <div className="flex justify-center items-center pt-5 select-none preview-action">
                <span className={`font-icon ${fileNumber === 0 && "disabled"}`}>
                  <FontAwesomeIcon
                    className={`cursor-pointer px-2.5 py-1.5 border-[#ECEEF5] border rounded-md ${
                      fileNumber === 0 && "opacity-40 pointer-events-none"
                    }`}
                    color="currentColor"
                    icon={faBackwardStep}
                    onClick={() => {
                      fileNumber > 0 && setFileNumber(fileNumber - 1);
                      setPage(1);
                    }}
                    title="Previous file"
                  />
                </span>
                <span className={` font-icon  ${page === 1 && "disabled"}`}>
                  <FontAwesomeIcon
                    className={`cursor-pointer px-2.5 py-1.5 border-[#ECEEF5] border rounded-md ${
                      page === 1 && "opacity-40 pointer-events-none"
                    }`}
                    color="currentColor"
                    icon={faChevronLeft}
                    onClick={() => page > 1 && setPage(page - 1)}
                    title="Previous page"
                  />
                </span>
                <div className="d-flex align-item-center gap-3">
                  <label className="font-icon px-2.5 py-1 rounded-md text-heading font-normal text-sm border-[#ECEEF5] border">
                    {page}
                  </label>
                  <label className="rounded-md text-heading font-bold text-sm">
                    of&nbsp;&nbsp;{numPages}
                  </label>
                </div>
                <span
                  className={`font-icon ${page === numPages && "disabled"}`}
                >
                  <FontAwesomeIcon
                    className={`cursor-pointer px-2.5 py-1.5 border-[#ECEEF5] border rounded-md ${
                      page === numPages && "opacity-40 pointer-events-none"
                    }`}
                    color="currentColor"
                    icon={faChevronRight}
                    title="Next page"
                    onClick={() => page < numPages && setPage(page + 1)}
                  />
                </span>
                <span 
                  className={`font-icon ${
                    fileNumber === selectFile.length - 1 &&
                    "disabled"
                  }`}
                >
                  <FontAwesomeIcon
                    className={`cursor-pointer px-2.5 py-1.5 border-[#ECEEF5] border rounded-md ${
                      fileNumber === selectFile.length - 1 &&
                      "opacity-40 pointer-events-none"
                    }`}
                    color="currentColor"
                    icon={faForwardStep}
                    onClick={() => {
                      fileNumber < selectFile.length - 1 &&
                        setFileNumber(fileNumber + 1);
                      setPage(1);
                    }}
                    title="Next file"
                  />
                </span>
              </div>
            ) : null}
          </>
        ) : (
          <div className="h-100">
            <label className="no-preview-wrapper">
              No preview available
            </label>
          </div>
        )}
      </div>
    );
};

export default PdfViewer;
